import React, { Component } from 'react'
import { Authenticate, SubmitOTPToLogin, LogoutUser,MobileNoCheckForEmail } from '../../Services/AccountServices';
import { useNavigate, Link, json } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import { GetNonUserToken } from "../../Services/NonUser"
import { ToastContainer, toast } from 'react-toastify';
import { CheckNetworkStatus, isValidateMobileNumber, isNumbersOnly, isValidateEmail} from '../../Utilities/Validations';
import { GetUserLocation,GetHeaderDetails } from "../../Services/UtilitiesServices";
import { GoogleLogin } from '@react-oauth/google';
import {decodeJwt} from 'jose'
import { GoogleAuthentication } from "../../Services/GoogleAuthentication"
import {useLocation} from "react-router-dom"
import { auth , provider} from "../../Configuration/firebase";
import { signInWithPopup, signOut, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { withTranslation } from 'react-i18next';

class HeaderNew extends Component {

  locationFetched = false;

  constructor(props) {
    super(props);
    this.state = {
      consularServicesUrl: "",
      isSticky: false,
    holidaysUrl: "https://www.alhindholidays.com/",
     countries: [
    { name: "India", code: "IN" },
    { name: "UAE", code: "AE" },
    // { name: "Qatar", code: "QA" },
    // { name: "Oman", code: "OM" },
    { name: "KSA", code: "SA" },
    // { name: "Bahrain", code: "BH" },
    // { name: "Kuwait", code: "KW" }
  ],
  selectedCountry: "India",
  selectedCountryCode: "IN",
      isEmailEntry: false,
      UserDetails: {},
      loginRequest: {},
      otpSubmitRequest: {},
      isOtpSent: false,
      isLoaded:false,
      isOtpSuccess:false,
      OtpResentOnce:0,    
      showButton: false,
      secondsRemaining: 60,
      IsRefresh:false,
      isGoogleAuthenticated: false,
      GoogleAuthenticatedEmail:"",
      isGoogleVerificationSuccess : false,
      credential:'',
      email:'',
      newEmail:'',
      psswd:''


    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.LoginOTP = this.LoginOTP.bind(this);
    this.SubmitOTP = this.SubmitOTP.bind(this);
    this.UserLogout = this.UserLogout.bind(this);
    this.UseAnotherMobileNumber = this.UseAnotherMobileNumber.bind(this);
    this.BackToSignIn = this.BackToSignIn.bind(this);
  }

fetchHeader = async () => {
  try {
    console.log("Calling API for country:", this.state.country);
    const res = await GetHeaderDetails();
    console.log("Header Response:", "executed");

    this.setState({
      consularServicesUrl: res.data.consularServicesUrl
    });
  } catch (error) {
    console.error("Header API error:", error);
  }
};

  changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
    
    document.body.dir = lng === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem("selectedLanguage", lng);

    const selectedCountryCode = localStorage.getItem("selectedCountryCode");

       if (selectedCountryCode === "IN") {
        this.props.i18n.changeLanguage('en');
        document.body.dir = 'ltr';
        localStorage.setItem("selectedLanguage", 'en');
      }

  };

  ///////////Page OnLoad/////////////////////////////
  async componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const savedLng = localStorage.getItem("selectedLanguage");
    if (savedLng) {
      this.props.i18n.changeLanguage(savedLng);
      document.body.dir = savedLng === 'ar' ? 'rtl' : 'ltr';
    }
    if(!window.navigator.onLine)
    {
      //Connection  Lost toast here...
    }
      this.fetchHeader(); // Header urls

    const holidaysMap = {
    IN: "https://www.alhindholidays.com/",
    AE: "https://ae.alhindholidays.com/",
    SA: "https://www.alhindholidays.com/",
    KW: "https://www.alhindholidays.com/"
  };

  let cached =
    localStorage.getItem("userLocation") 
    // ||
    // sessionStorage.getItem("userLocation")
    ;

    const allowedCountries = {
  IN: { name: "India", code: "IN" },
  AE: { name: "UAE", code: "AE" },
  SA: { name: "KSA", code: "SA" },
  KW: { name: "Kuwait", code: "KW" },
};

  let country = "India";
  let countryCode = "IN";

  if (cached) {
    const parsed = JSON.parse(cached);
    country = parsed.country;
    countryCode = parsed.countryCode || parsed.code || "IN";
  } else {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);

      const res = await fetch("https://ipapi.co/json/", {
        signal: controller.signal
      });

      clearTimeout(timeout);

      if (!res.ok) throw new Error("API failed");

      const data = await res.json();
      //console.log(data);

      let apiCountryCode = data.country || "IN";

      // Validate API Country
      if (allowedCountries[apiCountryCode]) {

        country = allowedCountries[apiCountryCode].name;
        countryCode = allowedCountries[apiCountryCode].code;

      } else {

        country = "India";
        countryCode = "IN";
      }

      // country = data.country_name;
      // countryCode = data.country;

    } catch {
      country = "India";
      countryCode = "IN";
    }

    this.handleCustomCountryChange(country, countryCode);

    // const formatted = { country, countryCode };

    // localStorage.setItem("userLocation", JSON.stringify(formatted));
    // sessionStorage.setItem("userLocation", JSON.stringify(formatted));
    // localStorage.setItem("selectedCountryCode", countryCode);
    // localStorage.setItem("selectedCountry", country);
  }

  this.setState({
    country,
    selectedCountry: country,
    selectedCountryCode: countryCode,
    holidaysUrl: holidaysMap[countryCode] || holidaysMap["IN"]
  });

  if (this.inputField) this.inputField.focus();

    
    let data={};

    if (localStorage.getItem("tokenValue") != null) {
      this.setState({
        UserDetails: JSON.parse(localStorage.getItem("TM_UDetails"))
      });
     
    }    
    else if(!localStorage.getItem('DeviceId') || !localStorage.getItem('NonUsertokenValue'))
    {
      if (!localStorage.getItem('DeviceId'))
      {
        const DeviceId = uuidv4();
       
       
        data.Id=DeviceId;
        localStorage.setItem('DeviceId',data.Id);
      }
      else if(!localStorage.getItem('NonUsertokenValue'))
      {
       
        data.Id=localStorage.getItem('DeviceId');
      }
      await GetNonUserToken(data).then((response) => {
      
      if (response.data.status) {
        localStorage.setItem('NonUsertokenValue', response.data.token);
        this.setState({
          isLoaded:true,
        })
      
        this.setState({
          DefaultUserLoginResponse: response.data,          
        });      
        
      }
    })
    .catch((error) => {
      this.setState({
        isLoaded:false,
      })
      
      toast.success('Something went wrong...', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
     
      if(error.response.data.responseMessage=="InvalidToken")
      {
        this.props.navigate('/');        
      }
    });
    }




  

  this.sleep(200000).then(() => {  
    this.componentDidMount();
  })
  .catch((error) => {
    if(error.response.data.responseMessage=="InvalidToken")
    {           
      this.props.navigate('/');            
    }
      // console.log(error);
    toast.success('Something went wrong...', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
  });
  
}
componentWillUnmount() {
    // Remove listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  }
getUserIpAddress = async () => {
  // 🔒 prevent multiple calls in same session
  if (this.locationFetched) return;

  this.locationFetched = true;

  const cached =
    localStorage.getItem("userLocation") ||
    sessionStorage.getItem("userLocation");

  if (cached) {
    const data = JSON.parse(cached);

    this.setState({
      country: data.country,
      selectedCountry: data.country,
      selectedCountryCode: data.countryCode
    });

    return;
  }

  try {
    console.log("🌍 Calling Location API...");

    const res = await GetUserLocation();
    const data = res.data;

    if (!data || !data.country) {
      console.warn("Invalid location data");
      return;
    }

    // Try both storages (private mode safe fallback)
    try {
      localStorage.setItem("userLocation", JSON.stringify(data));
    } catch {}

    try {
      sessionStorage.setItem("userLocation", JSON.stringify(data));
    } catch {}

    this.setState({
      country: data.country,
      selectedCountry: data.country
    });

  } catch (error) {
    console.error("Location error:", error);
  }
};

handleCustomCountryChange = async (name, code) => {
  if (!CheckNetworkStatus()) return;

  try {
    
    if (this.state.UserDetails?.userId) {
      await LogoutUser({ UserId: this.state.UserDetails.userId });
      this.googleSignOut();
    }

    
    localStorage.removeItem("TM_UDetails");
    localStorage.removeItem("tokenValue");
    localStorage.removeItem("DeviceId");
    localStorage.setItem("RS", null);

    
    const newData = { country: name, code: code };

    localStorage.setItem("userLocation", JSON.stringify(newData));
    sessionStorage.setItem("userLocation", JSON.stringify(newData));
    localStorage.setItem("selectedCountry", name);
    localStorage.setItem("selectedCountryCode", code);

    
    this.setState({
      selectedCountry: name,
      selectedCountryCode: code,
      country: name,
    });

    
    const countryRoutes = {
      AE: "/AE",
      SA: "/SA",
      QA: "/QA",
      BH: "/BH",
      OM: "/OM",
      KW: "/KW",
    };

    const route = countryRoutes[code] || "/";
    this.props.navigate(route);

    const selectedCountryCode = localStorage.getItem("selectedCountryCode");

       if (selectedCountryCode === "IN") {
        this.props.i18n.changeLanguage('en');
        document.body.dir = 'ltr';
        localStorage.setItem("selectedLanguage", 'en');
      }

    
    //window.location.reload();

  } catch (error) {
    console.error("Error in country change:", error);
  }
};

getHomeRoute = () => {
  const country = this.state.selectedCountryCode || localStorage.getItem("selectedCountryCode");

  const countryRoutes = {
    AE: "/AE",
    SA: "/SA",
    QA: "/QA",
    BH: "/BH",
    OM: "/OM",
    KW: "/KW",
  };

  return countryRoutes[country] || "/";
};

signInWithGoogle = async () => {
  signOut(auth).then((data)=>{
    try {
      // console.log(auth);
      // console.log(provider)
      provider.setCustomParameters({ prompt: 'select_account' });
    signInWithPopup(auth,provider).then((data)=>{
        //console.log(data);
  
        if(data.user.emailVerified)
        {
            // Call your API function with the necessary data
            this.IdTokenValidation( data._tokenResponse.oauthIdToken,  data.user.email );
        }
    });
    } catch (err){
      console.error(err);
    }
});

};

googleSignOut(){
  signOut(auth);
}



IdTokenValidation(credential,email){
  let data = {};
  data.idToken= credential;
  data.emailId = email;
  this.setState({
    credential: credential,          
    email: email,
  });
  GoogleAuthentication(data)
    .then((response) => {
      // Handle the API response here
      // console.log('Google Authentication API response', response);
      if (response.data.status && response.data.responseMessage == 'Logined Successfully') { 
        this.setState({
          isGoogleAuthenticated: false,  
          isGoogleVerificationSuccess :true,                
        });
        localStorage.setItem('tokenValue', response.data.token);
          localStorage.removeItem('NonUsertokenValue');
          localStorage.setItem('TM_UDetails', JSON.stringify(response.data.objUser));

          this.setState({
            isOtpSuccess:false,
            IsRefresh:true,
          })
         
          
          window.location.reload();
         
      }
      else if(response.data.status && response.data.responseMessage == 'Success')
      {
        let data = this.state.loginRequest;
        data.emailId = response.data.email;
        this.setState({
          isGoogleAuthenticated: true,
          GoogleAuthenticatedEmail : response.data.email,
          loginRequest : data,
          isGoogleVerificationSuccess : true,
        });
      }
      else
      {
        this.setState({
          isGoogleAuthenticated: false,
          isGoogleVerificationSuccess :false,
        });
      }
    })
    .catch((error) => {
      // Handle API call errors here
      console.error('Google Authentication API error', error);
    });
}

onSuccess = (credentialResponse) => {
  // console.log(credentialResponse);
  const { credential } = credentialResponse;
  const payload = credential ? decodeJwt(credential) : undefined;

  if (payload) {
    // console.log(payload);
    // console.log(payload.email);

    // Call your API function with the necessary data
    this.IdTokenValidation( credential,  payload.email );
  }
};



sleep = ms => {  
  return new Promise(resolve => setTimeout(resolve, ms));  
  }; 

UseAnotherMobileNumber(){
  this.setState({
    isOtpSent:false,
  })
}

BackToSignIn(){
  this.setState({
    isOtpSent:false,
    isEmailEntry:false,
    isGoogleAuthenticated:false
  })
}


  ///////////AUthentication/////////////////////////////
  LoginOTP() {
      
    //Check network connection...
    if(!CheckNetworkStatus())
        return;

    const mobileOrEmail = this.state.loginRequest.mobileNumber;

    //Check Valid Mobile...
    if(!isValidateMobileNumber(mobileOrEmail) && !isValidateEmail(mobileOrEmail))
    {
        toast.success('Invalid Email/Mobile Number...', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
        });
        return;
    }

    if(isValidateEmail(mobileOrEmail))
    { 
      let data = {
            ...this.state.loginRequest,
            isGoogleVerificationSuccess:
              this.state.isGoogleVerificationSuccess,
          };
          data.emailId = mobileOrEmail;

      MobileNoCheckForEmail(data).
        then((response) => {

          if (response.data.status) {  
            this.setState({
              isOtpSent: true,
              secondsRemaining: 60
            });

            let data = this.state.loginRequest;
            data.mobileNumber = response.data.mobileNumber;
            this.setState({
              loginRequest: data,
            })

            this.startTimer();
            return;
          }
          
           this.setState({
              email: mobileOrEmail,
              isEmailEntry: true,
              isGoogleAuthenticated: false,
            });

            return;
        })
        .catch((error) => {      
          // console.log(error);
          toast.success('Something went wrong...', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
      //   this.setState({email : this.state.loginRequest.mobileNumber,
      //   isEmailEntry:true,
      // isGoogleAuthenticated:false});
      //   return;

      
    }
    else
    {
      let data = {
            ...this.state.loginRequest,
            isGoogleVerificationSuccess:
              this.state.isGoogleVerificationSuccess,
          };

          if (this.state.email?.length > 0) {
            data.emailId = this.state.email;
          }
        
          if(this.state.OtpResentOnce <= 1)
            Authenticate(data).
              then((response) => {
                // console.log(response);
                if (response.data.status) {  
                  this.setState({
                    isOtpSent: true
                  });
                  this.startTimer();
                  this.setState({
                    secondsRemaining: 60,
                  })
                }
                else
                {
                  toast.warning(response.data.responseMessage, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'colored',
                  });
                }
              })
              .catch((error) => {      
                // console.log(error);
                toast.success('Something went wrong...', {
                  position: 'top-right',
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: 'colored',
                });
              });
    }

        
   
  }

  EnterBtnSubmit(event, type) {
    
    if(event.key=="Enter")
      if(type=="mob")
        this.LoginOTP();
      else
        this.SubmitOTP();

  }

  startTimer = () => {
    this.timer = setInterval(() => {
      this.setState(prevState => ({
        secondsRemaining: prevState.secondsRemaining - 1
      }), () => {
        if (this.state.secondsRemaining === 0) {
          this.setState({ showButton: true });
          clearInterval(this.timer);
        }
      });
    }, 1000); // 1 second
  };


   handleResendOTP = () => {
    this.setState({
      OtpResentOnce:this.state.OtpResentOnce + 1 ,

    })
    // Handle resend OTP logic here
    // For example, make an API call to resend the OTP
    this.setState({ showButton: false, secondsRemaining: 60 }, () => {
      this.startTimer();
      this.LoginOTP()
    });
  };


  ///////////OTP Submit/////////////////////////////
  SubmitOTP() {
      
    //Check network connection...
    if(!CheckNetworkStatus())
        return;

            //Check network connection...
    if(!isNumbersOnly(this.state.otpSubmitRequest.otp))
    {
      toast.success('Invalid OTP...', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
    });
    return;
    }
    
    //otpSubmitRequest.mobileNumber=loginRequest.mobileNumber;
    let data = {};
    data = this.state.otpSubmitRequest;
    data.mobileNumber = this.state.loginRequest.mobileNumber;
    data.otp=data.otp.trim();
    data.emailId=this.state.email;
    //console.log(data.emailId);
    data.idToken=this.state.credential;
    data.isGoogleAuthSuccess = this.state.isGoogleVerificationSuccess;
    
    SubmitOTPToLogin(data).
      then((response) => {
       if(response.data.status && response.data.responseMessage == "AddMobile")
       {
        //console.log(response.data);
        let l= this.state.loginRequest;
        l.emailId = response.data.objUser.email;
        
        this.setState({
          loginRequest:l,
          isOtpSent:false,
          isGoogleAuthenticated:true, //just for email login wchich not have mobile number
        })
       }
       else if (response.data.status) {
          localStorage.setItem('tokenValue', response.data.token);
          localStorage.removeItem('NonUsertokenValue');
          localStorage.setItem('TM_UDetails', JSON.stringify(response.data.objUser));
           localStorage.setItem('RS', JSON.stringify(response.data.recentSearchList));
          
          this.setState({
            isOtpSuccess:false,
            IsRefresh:true,
          })
          // this.componentDidMount();
          
          window.location.reload();
          // this.forceUpdate();
          //this.render();
        }
        else
        {
          this.setState({
              isOtpSuccess:true
          })
        }
      })
  }

  //////////////////// User Logout /////////////////////////////////////////
  UserLogout() {
      
    //Check network connection...
    if(!CheckNetworkStatus())
        return;

    LogoutUser({ UserId: this.state.UserDetails.userId }).
      then((response) => {
        this.googleSignOut();
        if (response.data.status) {
          localStorage.removeItem("TM_UDetails");
          localStorage.removeItem("tokenValue");
          localStorage.removeItem("DeviceId");
          localStorage.setItem("RS", null);
          window.location.reload();
        //   const DeviceId = uuidv4();      
        // let data={};
        // data.Id=DeviceId;
        // localStorage.setItem('DeviceId',data.Id);

        //   GetNonUserToken(data).then((response) => {
        //     //GetNonUserToken().then((response) => {

        
        //   if (response.data.status) {
            
        //     this.setState({
    
    
        //       DefaultUserLoginResponse: response.data,
              
        //     });

        //     localStorage.setItem('NonUsertokenValue', response.data.token);
        //    window.location.reload();
    
           
            
        //   }
        // })
        // .catch((error) => {

        //   if(error.response.data.responseMessage=="InvalidToken")
        //   {
        //     // Swal.fire(
        //     //   'Unauthorized Access !',
        //     //   'Please Login Again',
        //     //   'warning'
        //     // )
            
        //     this.props.navigate('/');
            
        //   }
        // });

        // window.location.reload();

        
        // if(localStorage.getItem("TM_UDetails")==null || localStorage.getItem("tokenValue"))
        // {

        // }
        // else
        //   window.location.reload();

        }

      })
     

  }
  /////////////////Input value set//////////////////////////////////////////////
  mobileInputChangeHandler = (event) => {
    const { name, value } = event.target
    let data = this.state.loginRequest;
    data.mobileNumber = value.trim();
    this.setState({
      loginRequest: data,
    })
  }

  /////////////////Input value set//////////////////////////////////////////////
  otpInputChangeHandler = (event) => {
    const { name, value } = event.target;
    let data = {};
    data.otp = value.trim();
    this.setState({
      otpSubmitRequest: data,
    })
  }


  ///////////Goto////////////////////////////////////////////////////////////////
  goto = (nav) => {
    this.props.navigate(nav);
  }

handleScroll = () => {
    if (window.scrollY > 40) {
      this.setState({ isSticky: true });
    } else {
      this.setState({ isSticky: false });
    }
  };
  render() {
const { t } = this.props;
    const { showButton, secondsRemaining } = this.state;

    let selectedcode =
    localStorage.getItem("selectedCountryCode") ||
    sessionStorage.getItem("selectedCountryCode");

  if (!selectedcode || selectedcode === "null") {
    selectedcode = "IN";
  }


    ///////Change in Header////////////////////////////////////////////////
    // let HeaderContent;
    // if (localStorage.getItem("tokenValue") != null) {
    //   HeaderContent = <div className="dropdown" id="logged">
    //     <a className="dropdown-toggle logged-text" type="button" id="account-login" data-bs-toggle="dropdown" aria-expanded="false"><span><img src="assets/img/user.svg" width={30} />
    //     </span> Hi {this.state.UserDetails.firstName} {" "}{this.state.UserDetails.lastName} !</a>
    //     <ul className="dropdown-menu" aria-labelledby="account-login">
    //       <li><a onClick={() => { this.goto('/Profile') }} className="dropdown-item" ><svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" className="bi bi-person mr-10" viewBox="0 0 16 16">
    //         <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
    //       </svg> My Profile</a></li>
    //       <li><a onClick={() => { this.goto('/MyTrips') }} className="dropdown-item"><svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" className="bi bi-briefcase mr-10" viewBox="0 0 16 16">
    //         <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
    //       </svg> My Trips</a></li>
    //       <li><a onClick={this.UserLogout} className="dropdown-item" ><svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" className="bi bi-box-arrow-left mr-10" viewBox="0 0 16 16">
    //         <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z" />
    //         <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
    //       </svg> Logout</a></li>
    //     </ul>
    //   </div>;
    // } else {
    //   HeaderContent = <div>

    //     <p data-bs-toggle="modal" data-bs-target="#exampleModal" className="login-link"><span><img src="assets/img/user.svg" width={30} /></span> Sign up</p>


    //     <div
    //       className="modal fade"
    //       id="exampleModal"
    //       tabIndex={-1}
    //       aria-labelledby="exampleModalLabel"
    //       aria-hidden="true"
    //     >
    //       <div className="modal-dialog">
    //         <div className="modal-content">
    //           <div className="modal-header">
    //             <h5 className="modal-title" id="exampleModalLabel">
    //               Sign in to your  Account!
    //             </h5>
    //             <button
    //               type="button"
    //               className="btn-close"
    //               data-bs-dismiss="modal"
    //               aria-label="Close"
    //             />
    //           </div>
    //           <div className="modal-body">
    //             {
    //               !this.state.isOtpSent && <div className="login-form">
                  
    //                 <div className="input-field">
    //                   <input
    //                     type="text"
    //                     name='mobileNumber'
    //                     required=""
    //                     spellCheck="false"
    //                     className="form-control mb-4"
    //                     onChange={(e) => this.mobileInputChangeHandler(e)}
    //                   />
    //                   <label>Enter your Mobile number</label>
    //                 </div>

    //                 <button type="button" onClick={this.LoginOTP} className="btn btn-primary f-login-btn">
    //                   SUBMIT
    //                 </button>
    //                 {/* <div className="pt-2">
    //                   <a href="" className="no-underline f-password">
    //                     Forgot Password?
    //                   </a>
    //               </div> */}
    //                 {/*  <div className="pt-2 pb-2">
    //                   <p className="or-section">Or</p>
    //                 </div> */}
    //                 {/* <div className="row">
    //                   <div className="col-md-6">
    //                     <a href="" className="google-login">
    //                       <img src="assets/img/otp.svg" width={40} /> Login with OTP
    //                     </a>
    //                   </div>
    //                   <div className="col-md-6">
    //                     <a href="" className="google-login">
    //                       <img src="assets/img/Google__G__Logo.svg" width={30} /> Sign in
    //                       with Google
    //                     </a>
    //                   </div>
    //                 </div> */}
    //                 <div className="pt-3 pb-3 small-text text-center">
    //                   <p>
    //                     By continuing, you agree to our{" "}
    //                     <a className="privacy-link">
    //                       privacy policy &amp; terms of use.
    //                     </a>
    //                   </p>
    //                 </div>
    //               </div>
    //             }
    //             {
    //               this.state.isOtpSent && <div className="login-form">
    //                 <p className="mb-3">An otp has been sent to your mobile number</p>
    //                 <div className="input-field">

    //                   <input
    //                     type="text"
    //                     name='otp'
    //                     required=""
    //                     spellCheck="false"
    //                     className="form-control mb-3"
    //                     onChange={(e) => this.otpInputChangeHandler(e)}
    //                   />
    //                   <label>Enter OTP</label>
    //                 </div>

                    

    //                 <button type="button" onClick={this.SubmitOTP} className="btn btn-primary f-login-btn">
    //                   LOGIN
    //                 </button>
    //                 {/* <div className="pt-2">
    //                   <a href="" className="no-underline f-password">
    //                     Forgot Password?
    //                   </a>
    //                 </div> */}
    //                 {/*<div className="pt-2 pb-2">
    //                   <p className="or-section">Or</p>
    //               </div>*/}
    //                 {/* <div className="row">
    //                   <div className="col-md-6">
    //                     <a href="" className="google-login">
    //                       <img src="assets/img/otp.svg" width={40} /> Login with OTP
    //                     </a>
    //                   </div>
    //                   <div className="col-md-6">
    //                     <a href="" className="google-login">
    //                       <img src="assets/img/Google__G__Logo.svg" width={30} /> Sign in
    //                       with Google
    //                     </a>
    //                   </div>
    //                 </div> */}
    //                 <div className="pt-3 pb-3 small-text text-center">
    //                   <p>
    //                     By continuing, you agree to our{" "}
    //                     <a className="privacy-link">
    //                       privacy policy &amp; terms of use.
    //                     </a>
    //                   </p>
    //                 </div>
    //               </div>
    //             }

    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //     ;
    // }
    ///////////////////////////////////////////////////////////////////////


    return (
      <div >
        <div className="top-nav d-flex">
          <div className="container">
           <div className="d-flex flex-row float-start align-items-center">
            
            </div> 
            <div className="d-flex flex-row-reverse float-end align-items-center">

              {/* {HeaderContent} */}

              
                <div>

       
        
        
             <div
  className="modal fade alhind-modal"
  id="exampleModal"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content">

      {/* ── Left panel ── */}
      <div className="alhind-login-left">
        <div className="brand-icon">
          
          {/* <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M20 6L24 16H16L20 6Z" fill="white"/>
            <rect x="10" y="20" width="20" height="10" rx="3" fill="white" opacity="0.9"/>
            <circle cx="20" cy="25" r="2.5" fill="#1a56a0"/>
          </svg> */}
          <img src="/assets/img/favicon.png" width={50} />
        </div>
        <div>
          <p className="brand-title">{t("welcome")}</p>
          <p className="brand-sub">{t("sign_in_caption")},<br/>{t("holidays")} &amp; {t("more")}</p>
        </div>
        <div className="feature-list">
          <div className="feature-item">
            <div className="feature-icon">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                <path d="M8 1L10 6H15L11 9.5L12.5 15L8 11.5L3.5 15L5 9.5L1 6H6L8 1Z" fill="white"/>
              </svg>
            </div>
            <p className="feature-text">{t("sign_deal1")}</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="white" strokeWidth="1.5"/>
                <path d="M8 5V8L10 10" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <p className="feature-text">{t("sign_deal2")}</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                <path d="M3 8L6.5 11.5L13 4.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <p className="feature-text">{t("sign_deal3")}</p>
          </div>
        </div>
      </div>

      {/* ── Right panel ── */}
      <div className="alhind-login-right">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          style={{ position: "absolute", top: 16, right: 16 }}
        />

        {/* After Google Authentication — mobile entry */}
        {!this.state.isOtpSent && this.state.isGoogleAuthenticated && !this.state.isEmailEntry && (
          <div>
            <p className="form-title">
              {t("mobile_number")}
              <a onClick={this.BackToSignIn} className="alhind-edit-link">
                <img src="/assets/img/edit.png" width={18} alt="edit" />
              </a>
            </p>
            <p className="form-sub">Enter your mobile to continue</p>

            <div className="alhind-field-wrap">
              <label className="field-label">{t("mobile")}</label>
              <input
                type="text"
                name="mobileNumber"
                placeholder={t("enter_mobile")}
                ref={(input) => { this.inputField = input; }}
                onKeyDown={(e) => this.EnterBtnSubmit(e, "mob")}
                onChange={(e) => this.mobileInputChangeHandler(e)}
              />
            </div>

            <button type="button" onClick={this.LoginOTP} className="alhind-btn-primary">
              {t("continue")}
            </button>

            <button className="alhind-btn-outline" onClick={() => { this.signInWithGoogle(); }}>
              <svg width="16" height="16" viewBox="0 0 18 18">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
                <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Change Google Account
            </button>

            <p className="alhind-privacy">
              {t("by_continuing")}
              {" "}
              <a className="privacy-link">{t("privacy_policy")} &amp; {t("terms_of_use")}</a>
            </p>
          </div>
        )}

        {/* After Email Id — mobile entry */}
        {!this.state.isOtpSent && !this.state.isGoogleAuthenticated && this.state.isEmailEntry && (
          <div>
            <p className="form-title">{t("mobile_number")}</p>
            <p className="form-sub">{t("email")}: {this.state.email}</p>

            <div className="alhind-field-wrap">
              <label className="field-label">{t("mobile")}</label>
              <input
                type="text"
                name="mobileNumber"
                placeholder={t("enter_mobile")}
                ref={(input) => { this.inputField = input; }}
                onKeyDown={(e) => this.EnterBtnSubmit(e, "mob")}
                onChange={(e) => this.mobileInputChangeHandler(e)}
              />
            </div>

            <button type="button" onClick={this.LoginOTP} className="alhind-btn-primary">
              {t("continue")} 
            </button>

            {this.state.selectedCountryCode === "IN" && (
              <button type="button" onClick={this.BackToSignIn} className="alhind-btn-outline">
                {t("already_have_account")}
              </button>
            )}


            <p className="alhind-privacy">
              {t("by_continuing")}
              {" "}
              <a className="privacy-link">{t("privacy_policy")} &amp; {t("terms_of_use")}</a>
            </p>
          </div>
        )}

        {/* Mobile / Email Entry (default) */}
        {!this.state.isOtpSent && !this.state.isGoogleAuthenticated && !this.state.isEmailEntry && (
          <div>
            <p className="form-title">{t("sign_in")}</p>
         <p className="form-sub">
  {this.state.selectedCountry === "India"
    ? t("enter_mobile")
    : t("enter_email")
  }
</p>

            <div className="alhind-field-wrap">
              <label className="field-label">
                {this.state.selectedCountry === "India" ? t("email_mobile") : t("email")}
              </label>
              <input
                type="text"
                name="mobileNumber"
                placeholder={this.state.selectedCountry === "India" ? "you@email.com or 9XXXXXXXXX" : "you@email.com"}
                ref={(input) => { this.inputField = input; }}
                onKeyDown={(e) => this.EnterBtnSubmit(e, "mob")}
                onChange={(e) => this.mobileInputChangeHandler(e)}
              />
            </div>

            <button type="button" onClick={this.LoginOTP} className="alhind-btn-primary">
              {t("continue")}
            </button>
{/* 
            <div className="alhind-divider">
              <hr /><span>or</span><hr />
            </div> */}

            {/* <button className="alhind-btn-outline" onClick={() => { this.signInWithGoogle(); }}>
              <svg width="16" height="16" viewBox="0 0 18 18">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
                <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Continue with Google
            </button> */}

            <p className="alhind-privacy">
              {t("by_continuing")}
              {" "}
              <a className="privacy-link">{t("privacy_policy")} &amp; {t("terms_of_use")}</a>
            </p>
          </div>
        )}

        {/* OTP Verification */}
        {this.state.isOtpSent && (
          <div className="login-form">
            <p className="form-title">{t("otp_verification")}</p>
            <p className="form-sub">
              {this.state.selectedCountryCode === "IN" ? (
                <>
                  {t("sent_to")}: <strong>{this.state.loginRequest.mobileNumber}</strong>
                  <a onClick={this.UseAnotherMobileNumber} className="alhind-edit-link">
                    <img src="/assets/img/edit.png" width={16} alt="edit" />
                  </a>
                </>
              ) : (
                t("otp_sent_to_email")
              )}
            </p>

            <div className="alhind-field-wrap">
              <label className="field-label">{t("otp")}</label>
              <input
                autoFocus
                type="text"
                name="otp"
                className="alhind-otp-input"
                placeholder="••••••"
                autoComplete="off"
                onKeyDown={(e) => this.EnterBtnSubmit(e, "otp")}
                onChange={(e) => this.otpInputChangeHandler(e)}
              />
              {this.state.isOtpSuccess && (
                <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                  Please enter a valid OTP
                </span>
              )}
            </div>

            <div className="alhind-resend">
              {showButton ? (
                this.state.OtpResentOnce < 1 && (
                  <span role="button" onClick={this.handleResendOTP}>
                    {t("resend_otp")}
                  </span>
                )
              ) : (
                this.state.OtpResentOnce < 1 && (
                  <span>{t("resend_otp")} in: {secondsRemaining}s</span>
                )
              )}
            </div>

            <button type="button" onClick={this.SubmitOTP} className="alhind-btn-primary">
              {t("login")}
            </button>

            <p className="alhind-privacy">
              {t("by_continuing")}
              {" "}
              <a className="privacy-link">{t("privacy_policy")} &amp; {t("terms_of_use")}</a>
            </p>
          </div>
        )}
      </div>
      {/* end right panel */}

    </div>
  </div>
</div>
              </div>
      

            </div>
          </div>
        </div>
       

<div className={`main-nav ${this.state.isSticky ? 'fixed-top shadow bg-white animated fadeInDown' : ''}`}>
  <nav className="navbar navbar-expand-lg navbar-light p-0">
    <div className="container-fluid">
     
      <Link to={this.getHomeRoute()} className="navbar-brand d-flex align-items-center m-0 text-primary">
        <img className="logo-main me-2" src="/assets/img/logo-alhind.webp" alt="Logo" />
      </Link>

   
      <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
        <span className="navbar-toggler-icon" />
      </button>

      
      <div className="collapse navbar-collapse" id="navbarCollapse">
        
   
      <div className="navbar-nav me-auto py-2 horizontal-scroll nav-box-container">
  <Link to={this.getHomeRoute()} className="nav-box">
    <div className="menu-icon"><img src="/assets/img/flight.png" alt="Flights" /></div>
    <span>{t('flights')}</span>
  </Link>
  
  <Link to="Visa" className="nav-box">
    <div className="menu-icon"><img src="/assets/img/visa.png" alt="Visa" /></div>
    <span>{t('visa')}</span>
  </Link>
  
  <Link to="Forex" className="nav-box">
    <div className="menu-icon"><img src="/assets/img/forex.png" alt="Forex" /></div>
    <span>{t('forex')}</span>
  </Link>
  
  <Link to="Umrah" className="nav-box">
    <div className="menu-icon"><img src="/assets/img/umrah.png" alt="Umrah" /></div>
    <span>{t('umrah')}</span>
  </Link>
  
  {/* <a href="http://www.alhindbus.com/" target="_blank" rel="noreferrer" className="nav-box">
    <div className="menu-icon"><img src="/assets/img/buss.png" alt="Bus" /></div>
    <span>Bus</span>
  </a> */}

 
 <a href={this.state.holidaysUrl} target="_blank" rel="noopener noreferrer" className="nav-box">
  <div className="menu-icon">
    <img src="/assets/img/bus.png" alt="Holidays" />
  </div>
  <span>{t('holidays')}</span>
</a>
  <a href="https://www.alhindattestation.com/" target="_blank" rel="noreferrer" className="nav-box" style={{width: '130px'}}>
    <div className="menu-icon"><img src="/assets/img/attestation.png" alt="Attestation" /></div>
    <span>{t('attestation')}</span>
  </a> 



{this.state.consularServicesUrl && (
  <a href={this.state.consularServicesUrl} rel="noopener noreferrer" className="nav-box" style={{width: '180px'}}>
    <div className="menu-icon">
      <img src="/assets/img/passport.png" alt="Passport" />
    </div>
    <span>{t('passport')}</span>
  </a>
)}

</div>



        {/* Login/User Section (Right side) */}
       <div className="d-flex align-items-center ms-auto">  
       {/* Language Selector Dropdown */}
  {this.state.selectedCountryCode !== "IN" && <div className="me-2 dropdown">
  <button 
    className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center lang-selector-btn" 
    type="button" 
    id="langDropdown" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style={{ backgroundColor: "#fff", fontSize: "13px" }}
  >
    
    {this.props.i18n.language === 'ar' ? 'العربية' : 'English'}
  </button>
  
  <ul className="dropdown-menu shadow" aria-labelledby="langDropdown" style={{ fontSize: "13px" }}>
      <li>
      <button 
        className="dropdown-item d-flex align-items-center" 
        type="button"
        onClick={() => this.changeLanguage('ar')}
      >
        العربية
      </button>
    </li>
    <li>
      <button 
        className="dropdown-item d-flex align-items-center" 
        type="button"
        onClick={() => this.changeLanguage('en')}
      >
        English
      </button>
    </li>
  
  </ul>
</div> 
}
  
<div className="me-2 dropdown">
  <button 
    className="btn btn-sm btn-outline-secondary dropdown-toggle d-flex align-items-center country-selector-btn" 
    type="button" 
    id="countryDropdown" 
    data-bs-toggle="dropdown" 
    aria-expanded="false"
    style={{ backgroundColor: "#fff", width: "110px" }}
  >
    <img 
      src={`https://flagcdn.com/w20/${selectedcode.toLowerCase()}.png`} 
      alt="" 
      className="me-2" 
      style={{ width: "20px" }}
    />
    {this.state.selectedCountry}
  </button>
  
  <ul className="dropdown-menu shadow" aria-labelledby="countryDropdown" style={{ fontSize: "13px" }}>
    {this.state.countries.map((c, index) => (
      <li key={index}>
        <button 
          className="dropdown-item d-flex align-items-center" 
          type="button"
          onClick={() => this.handleCustomCountryChange(c.name, c.code)}
        >
          <img 
            src={`https://flagcdn.com/w20/${c.code.toLowerCase()}.png`} 
            alt={c.name} 
            className="me-2" 
            style={{ width: "20px" }}
          />
          {c.name}
        </button>
      </li>
    ))}
  </ul>
</div>
       {localStorage.getItem("tokenValue") != null && this.state.UserDetails ? (
  <div className="nav-item dropdown custom-user-dropdown">
    <button 
      className="user-profile-trigger" 
      id="account-login" 
      data-bs-toggle="dropdown" 
      aria-expanded="false"
    >
      <div className="avatar-wrapper">
        <img src="/assets/img/user.png" alt="User" />
      </div>
      <span className="user-name">Hi, {this.state.UserDetails.firstName}</span>
      <i className="bi bi-chevron-down ms-2 small-icon"></i>
    </button>
    
    <ul className="dropdown-menu dropdown-menu-end modern-dropdown-menu">
      <li className="dropdown-header">{t('manage_account')}</li>
      <li>
        <a onClick={() => this.goto('/Profile')} className="dropdown-item">
          <i className="bi bi-person me-2"></i> {t('my_profile')}
        </a>
      </li>
      <li>
        <a onClick={() => this.goto('/MyTrips')} className="dropdown-item">
          <i className="bi bi-geo-alt me-2"></i> {t('my_trips')}
        </a>
      </li>
      <li><hr className="dropdown-divider" /></li>
      <li>
        <a onClick={this.UserLogout} className="dropdown-item logout-item">
          <i className="bi bi-box-arrow-right me-2"></i> {t('logout')}
        </a>
      </li>
    </ul>
  </div>
) : (
  <div className="nav-item">
    <button 
      data-bs-toggle="modal" 
      data-bs-target="#exampleModal" 
      className="btn-modern-primary"
    >
      {t('login')}
    </button>
  </div>
)}
        </div>
        
      </div>
    </div>
  </nav>
</div>
        <ToastContainer />
      </div>
    )
  }
}


function WithNavigate(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const TranslatedHeader = withTranslation()(HeaderNew);
  return <TranslatedHeader {...props} navigate={navigate} location={location} />;
}

export default WithNavigate;
